/* EclatDent — tiroir d'upsell : s'ouvre à chaque ajout au panier, jauge livraison + suggestions */
(() => {
  if (window.__edupInit) return;
  window.__edupInit = true;

  const root = document.querySelector('[data-edup]');
  if (!root) return;
  // le panier a déjà sa jauge et son upsell : pas de tiroir là-bas
  if (document.querySelector('[data-edcart]')) return;

  const freeQty = Number(root.dataset.freeQty) || 2;
  const shipPrice = root.dataset.shipPrice || '';
  // 19/09 : palier du pays de session (snippet ed-ship-zone). Hors France et UE, la gratuité dépend du MONTANT (40 €), pas des tubes.
  const zone = root.dataset.shipZone || 'fr';
  const horsUE = zone === 'intl' || zone === 'monde';
  const seuil = Number(root.dataset.shipSeuil) || 4000;
  // 02/11 : seuil RÉEL (gratuité, France 19,90 €) et seuil ANNONCÉ (textes et « plus que X € », France 20 €)
  const annonce = Number(root.dataset.shipAnnonce) || seuil;
  const zonePrice = root.dataset.shipZonePrice || shipPrice;
  // Chaînes traduites injectées par le snippet (locales/*.json, ed.up.js_*)
  const T = {
    free: root.dataset.tFree || '🚀 <b>Livraison offerte</b> en France et dans l’UE, c’est cadeau.',
    missingOne: root.dataset.tMissingOne || 'Plus que <b>1 tube</b> pour la <b>livraison offerte</b> en France et dans l’UE (sinon [price] en France)',
    missingMany: root.dataset.tMissingMany || 'Plus que <b>[count] tubes</b> pour la <b>livraison offerte</b> en France et dans l’UE (sinon [price] en France)',
    packDiff: root.dataset.tPackDiff || 'Pour <b>[diff] de plus</b>, passe au <b>pack 3 tubes</b> : ton 3ᵉ tube est quasi offert.',
    suggestFree: root.dataset.tSuggestFree || 'Complète ta routine, livraison toujours offerte (France & UE) :',
    suggestAdd: root.dataset.tSuggestAdd || 'Ajoute un tube, la livraison est offerte (France & UE) :',
    missingAmount: root.dataset.tMissingAmount || 'Plus que <b>[amount]</b> pour la <b>livraison offerte</b> dès [threshold] (sinon [price] vers votre pays)',
    freeIntl: root.dataset.tFreeIntl || '🚀 <b>Livraison offerte</b> vers votre pays, c’est cadeau.',
  };
  const panel = root.querySelector('.edup-panel');
  const shipLabel = root.querySelector('[data-edup-ship-label]');
  const fill = root.querySelector('[data-edup-fill]');
  const totalEl = root.querySelector('[data-edup-total]');
  const suggest = root.querySelector('[data-edup-suggest]');
  const suggestHead = root.querySelector('[data-edup-suggest-head]');
  let chips = [...root.querySelectorAll('[data-edup-add]')];
  const tubeChips = chips.slice();
  const packEl = root.querySelector('[data-edup-pack]');
  const packText = root.querySelector('[data-edup-pack-text]');
  const packDefaultHtml = packText ? packText.innerHTML : '';

  let fmt = null;
  function money(cents, currency) {
    if (!fmt || fmt.currency !== currency) {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: currency || 'EUR' });
      fmt.currency = currency;
    }
    return fmt.format(cents / 100);
  }

  // Règle miroir de snippets/cart-tube-count.liquid : toute modification doit être faite aux deux endroits.
  function tubesPerUnit(handle) {
    const h = String(handle || '');
    if (h.includes('duo')) return 2;
    if (h.includes('pack') || h.includes('-x3')) return 3;
    return 1;
  }

  function render(cart) {
    const items = cart.items || [];
    // 01/11 : seuls les dentifrices comptent comme des tubes (miroir de snippets/cart-tube-count.liquid)
    const tubes = items.filter((i) => /entifrice/i.test(i.product_type || ''));
    const count = tubes.reduce((n, i) => n + i.quantity * tubesPerUnit(i.handle), 0);
    const hasPack = tubes.some((i) => tubesPerUnit(i.handle) > 1);
    const hasSub = items.some((i) => i.selling_plan_allocation);
    const total = cart.total_price || 0;
    // l'abonnement Club éclat+ a la livraison offerte dans tous les pays (remise automatique sans plafond)
    // 01/11 : en France et dans l'UE, la gratuité est aussi atteinte au MONTANT (France et UE : 20 € annoncés, 19,90 € réels depuis le 03/11/2026), comme au paiement ;
    // un panier sans tube (accessoires, strass) parle en euros, plus en tubes.
    // 02/11 : France dès 20 € (2 tubes = 19,98 €) : la gratuité se lit au MONTANT partout
    const parMontant = true;
    const free = hasSub || total >= seuil;
    root.classList.toggle('is-free', free);
    if (shipLabel) {
      if (free) {
        shipLabel.innerHTML = horsUE ? T.freeIntl : T.free;
      } else if (parMontant) {
        shipLabel.innerHTML = T.missingAmount
          .replace('[amount]', money(annonce - total, cart.currency))
          .replace('[threshold]', money(annonce, cart.currency))
          .replace('[price]', zonePrice);
      } else {
        const missing = freeQty - count;
        const tpl = missing > 1 ? T.missingMany : T.missingOne;
        shipLabel.innerHTML = tpl.replace('[count]', String(missing)).replace('[price]', shipPrice);
      }
    }
    if (fill) fill.style.width = Math.min(100, ((parMontant ? total / annonce : count / freeQty) * 100)) + '%';
    if (totalEl) totalEl.textContent = money(cart.total_price || 0, cart.currency);
    // 02/11 (audit) : origine réelle des colis (dentifrices : France ; accessoires et strass : partenaire logistique)
    const trustEl = root.querySelector('[data-edup-trust]');
    const colisEl = root.querySelector('[data-edup-colis]');
    const aFr = tubes.length > 0;
    const aPart = items.length > tubes.length;
    if (trustEl) trustEl.textContent = (aPart && !aFr) ? trustEl.dataset.tPart : trustEl.dataset.tFr;
    if (colisEl) colisEl.hidden = !(aPart && aFr);
    if (trustEl) trustEl.hidden = aPart && aFr;

    if (packEl && packText) {
      packEl.hidden = hasPack || count === 0;
      const packPrice = Number(packEl.dataset.packPrice) || 0;
      const tubePrice = Number(packEl.dataset.tubePrice) || 0;
      const diff = packPrice - (cart.total_price || 0);
      if (!hasPack && packPrice && diff > 0 && diff < tubePrice) {
        packText.innerHTML = T.packDiff.replace('[diff]', money(diff, cart.currency));
      } else {
        packText.innerHTML = packDefaultHtml;
      }
    }

    const inCart = new Set(items.map((i) => String(i.product_id)));
    let visible = 0;
    chips.forEach((chip) => {
      const owned = inCart.has(String(chip.dataset.productId));
      chip.classList.toggle('in-cart', owned || visible >= 3);
      if (!owned && visible < 3) visible++;
    });
    if (suggest) suggest.hidden = visible === 0;
    if (suggestHead) {
      suggestHead.textContent = recoActive ? T.reco : (free ? T.suggestFree : T.suggestAdd);
    }
  }

  // 01/11 : suggestions selon le DERNIER article ajouté (Section Rendering de sa fiche : gamme.ensemble) ;
  // un dentifrice ou un pack garde les tubes. Cache par produit, aucun appel si l'article n'a pas d'associations.
  let recoActive = false;
  const recoCache = new Map();
  T.reco = root.dataset.tReco || T.suggestFree;
  function bindChip(chip) {
    chip.addEventListener('click', () => {
      chip.setAttribute('disabled', 'disabled');
      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(chip.dataset.variant), quantity: 1 }] }),
      }).then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(() => {
        chip.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(() => { chip.removeAttribute('disabled'); });
    });
  }
  const routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  async function reco(cart) {
    const last = (cart.items || [])[0];
    if (!last || !suggest) return;
    let html = recoCache.get(last.product_id);
    if (html === undefined) {
      try {
        const r = await fetch(routeRoot + 'products/' + encodeURIComponent(last.handle) + '?section_id=ed-reco-tiroir');
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const box = doc.querySelector('[data-edup-reco]');
        html = box && box.querySelector('[data-edup-add]') ? box.innerHTML : '';
      } catch (e) { html = ''; }
      recoCache.set(last.product_id, html);
    }
    suggest.querySelectorAll('[data-edup-add]').forEach((c) => c.remove());
    if (html) {
      suggest.insertAdjacentHTML('beforeend', html);
      chips = [...suggest.querySelectorAll('[data-edup-add]')];
      chips.forEach(bindChip);
      recoActive = true;
    } else {
      tubeChips.forEach((c) => suggest.appendChild(c));
      chips = tubeChips.slice();
      recoActive = false;
    }
    render(cart);
  }

  function open() {
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('open'));
    document.documentElement.classList.add('edup-lock');
    if (panel) panel.focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('open');
    document.documentElement.classList.remove('edup-lock');
    setTimeout(() => { root.hidden = true; }, 300);
  }

  root.querySelectorAll('[data-edup-close]').forEach((b) => b.addEventListener('click', close));
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });

  document.addEventListener('cart:refresh', () => {
    fetch('/cart.js').then((r) => r.json()).then((cart) => {
      if (!cart.item_count) { if (!root.hidden) close(); return; }
      render(cart);
      reco(cart);
      if (root.hidden) open();
    }).catch(() => {});
  });

  tubeChips.forEach(bindChip);
})();
